import axios from 'axios';
import FileSaver from 'file-saver';
import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit';
import { error, isFetching } from './common';
import { OdataParams } from '@pec/aion-ui-odata/types/odataParams';

const name = 'downloadReport';

export type Params = {
  url: string;
  fileName?: string;
  filter?: string;
  select?: string;
  params?: OdataParams;
  removeOrgHeader?: boolean;
  extraParams?: object;
};

export const fetchReport = createAsyncThunk(
  `${name}/fetchReport`,
  async ({ url, fileName, params, removeOrgHeader, extraParams }: Params) => {
    const { data, headers } = await axios.get<BlobPart>(url, {
      params: { ...params, ...extraParams },
      responseType: 'arraybuffer',
      headers: {
        Accept: 'text/csv'
      },
      transformRequest: (data, headers) => {
        removeOrgHeader && delete headers['X-Aion-OrganizationId'];
        return data;
      }
    });

    const blob = new Blob([data], { type: headers['content-type'] });

    FileSaver.saveAs(blob, fileName);
  }
);

export type State = {
  isFetching: boolean;
  error: SerializedError | null;
};

export const initialState: State = {
  isFetching: false,
  error: null
};

const downloadReport = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchReport.pending, isFetching);
    builder.addCase(fetchReport.fulfilled, state => {
      state.isFetching = false;
    });
    builder.addCase(fetchReport.rejected, error);
  }
});

export const { reducer: downloadReportReducer } = downloadReport;
